import React from 'react';
import FloatingNav from './FloatingNav';
import Footer from './Footer';
import SeoTags from './SeoTags';
import AIAssistant from './AIAssistant';

const Layout = ({ children, openModal }) => {
  return (
    <div className="flex flex-col min-h-screen bg-[var(--bg-canvas)] text-white relative">
      <SeoTags />

      {/* Ambient Glow for Apple / Grok Aesthetic */}
      <div className="ambient-glow" />

      {/* Floating Navigation — replaces Sidebar + Topbar */}
      <FloatingNav />

      {/* Main Content */}
      <main className="flex-1 min-w-0">
        {children}
      </main>

      <Footer />
      <AIAssistant />
    </div>
  );
};

export default Layout;